import * as HttpService from './HttpService'

let namespace = 'customers'

let customerRevenue = (params, cb, errorCb) => {
    HttpService.get(namespace, params, cb, errorCb)
}

let customerActivity = (params, cb, errorCb) => {
    HttpService.get('customer-activity', params, cb, errorCb)
}

let customerCategoryActivity = (params, cb, errorCb) => {
    HttpService.get('customer-category-activity', params, cb, errorCb)
}

let typeRevenue = (params, cb, errorCb) => {
    HttpService.get('customer-categories', params, cb, errorCb)
}

let customerRevenueSingle = (uuid, params, cb, errorCb) => {
    HttpService.get(namespace + '/' + uuid, params, cb, errorCb)
}

export {
    customerRevenue,
    customerActivity,
    customerCategoryActivity,
    typeRevenue,
    customerRevenueSingle
}



// WEBPACK FOOTER //
// ./src/services/customerService.js